import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';
import { AdvSearchService } from '../../services/adv-search.service';
import { UserDataService } from '../../services/user-data.service';
import { TabDataService } from '../../services/tab-data.service';
import { InboxService } from '../../services/inbox.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppUtils } from '../../common/utility/appUtil';
import $ from 'jquery';
import { QmaConstant } from "../../constant/qma-constant";
import { PiwikProUtils } from '../../common/utility/piwikProUtils';
import { ClientCategory } from '../../model/LoginUserInfo/clientCategory';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-adv-criteria',
  templateUrl: './adv-criteria.component.html',
  styleUrls: ['./adv-criteria.component.scss'],
})
export class AdvCriteriaComponent implements OnInit {
  @ViewChild("advSearchContainer", { static: true }) advSearchContainer: ElementRef; // Tracks clicks outside the advanced search container.
  @ViewChild('addFiltersOverlay', { static: false }) addFiltersOverlay?: OverlayPanel;
  @Output() searchToggle = new EventEmitter();
  error: any = { isError: false, errorMessage: '' };
  isSubmitted = false;
  public advSearchForm: FormGroup;
  public advSearchError = false;
  datePresetOptions: Array<{ label: string; value: string }> = [
    { label: 'Any', value: 'ANY' },
    { label: 'In the last 7 days', value: 'LAST_7_DAYS' },
    { label: 'In the last 30 days', value: 'LAST_30_DAYS' },
    { label: 'In the last 6 Months', value: 'LAST_6_MONTHS' },
    { label: 'Custom Range', value: 'CUSTOM_RANGE' }
  ];

  /** Search In dropdown (enhanced search row) — labels match UI spec */
  searchInScopeOptions: Array<{ label: string; value: string }> = [
    { label: 'All', value: 'ALL' },
    { label: 'Inbox', value: 'Inbox' },
    { label: 'Pending Approval', value: 'Pending Approval' },
    { label: 'Resolved', value: 'Resolved' },
    { label: 'Sent', value: 'Sent' }
  ];

  /** End of today in the user's local timezone. Used as maxDate so only today and past dates are selectable; tomorrow is disabled (works for US, India, etc.). */
  maxSelectableDate: Date;

  /** Add filters dropdown options (enhanced search) */
  addFilterOptions: Array<{ key: string; label: string }> = [
    { key: 'FILE_NAME', label: 'File Name' },
    { key: 'SIZE', label: 'Size' },
    { key: 'TAG', label: 'Tag' },
    { key: 'CLIENT_CATEGORY', label: 'Client Category' },
    { key: 'STATUS', label: 'Status' },
    { key: 'SEARCH_IN_SNOOZED', label: 'Search in Snoozed' }
  ];

  /** Selected add-on filters (adds rows to enhanced search section). Resets on close/exit. */
  selectedEnhancedFilterKeys: string[] = [];
  isAddFiltersOpen = false;
  isSmallViewport = false;

  /** Options for added filter controls */
  sizeComparatorOptions: Array<{ label: string; value: string }> = [
    { label: 'Select', value: '' },
    { label: '>', value: 'GT' },
    { label: '≥', value: 'GTE' },
    { label: '=', value: 'EQ' },
    { label: '≤', value: 'LTE' },
    { label: '<', value: 'LT' }
  ];
  sizeUnitOptions: Array<{ label: string; value: string }> = [
    { label: 'KB', value: 'KB' },
    { label: 'MB', value: 'MB' },
    { label: 'GB', value: 'GB' }
  ];
  /** Populated in ngOnInit from loggedInUserInfo.clientCategories */
  clientCategoryOptions: Array<{ label: string; value: string }> = [{ label: 'Select', value: '' }];
  statusOptions: Array<{ label: string; value: string }> = [
    { label: 'Select', value: '' },
    { label: 'Open', value: 'Open' },
    { label: 'Resolved', value: 'Resolved' }
  ];

  @HostListener('document:click', ['$event'])
  click(e) {
    // PrimeNG overlays are rendered under body and should not close advanced search.
    if (this.isPrimeNgOverlayEvent(e)) return;

    if (window.innerWidth <= QmaConstant.MOBILE_WIDTH) {
      const targetEl = this.getEventTargetElement(e?.target);
      const composedPathFn = e?.composedPath;
      const path = typeof composedPathFn === 'function' ? composedPathFn.call(e) : [];

      const advEl = document.getElementById('adv');
      const inAdv =
        (!!targetEl && (advEl?.contains(targetEl) || !!targetEl.closest('.advance-search'))) ||
        (Array.isArray(path) && advEl ? path.includes(advEl) : false) ||
        (Array.isArray(path) && path.some((n: any) => n instanceof HTMLElement && (n.id === 'adv' || n.classList?.contains('advance-search'))));

      if (inAdv) {
        $('#adv').show();
        return;
      }

      let adv_elems = $(e.target).parents('.adv-search-button');
      if (this.advSearchContainer &&
        this.advSearchContainer.nativeElement &&
        this.advSearchContainer.nativeElement.contains(e.target) ||
        adv_elems.length ||
        $(e.target).hasClass('adv-search-button')) {
        $('#adv').show();
      } else {
        $('#adv').hide();
      }
    }
  }

  private getEventTargetElement(target: any): HTMLElement | null {
    if (!target) return null;
    if (target instanceof HTMLElement) return target;
    // Text nodes (nodeType 3) can be event targets in some browsers/cases
    if (target.nodeType === 3 && target.parentElement instanceof HTMLElement) return target.parentElement;
    if (target.parentElement instanceof HTMLElement) return target.parentElement;
    return null;
  }

  private isPrimeNgOverlayInteraction(target: HTMLElement): boolean {
    // Supports both current PrimeNG (.p-*) and older PrimeUI (.ui-*) classes.
    const selectors = [
      // Dropdown/menu/overlay containers
      '.p-dropdown-panel',
      '.p-overlay',
      '.p-overlaypanel',
      '.p-connected-overlay',
      '.p-component-overlay',
      // Datepicker/calendar containers
      '.p-datepicker',
      '.p-datepicker-header',
      '.p-calendar',
      // Common interactive inner elements for safety
      '.p-dropdown-item',
      '.p-dropdown-items',
      '.p-dropdown-items-wrapper',
      '.p-dropdown-label',
      '.p-dropdown-trigger',

      // Older PrimeNG/PrimeUI classnames
      '.ui-dropdown-panel',
      '.ui-overlaypanel',
      '.ui-widget-overlay',
      '.ui-datepicker',
      '.ui-datepicker-header',
      '.ui-calendar',
      '.ui-dropdown-item'
    ];

    return selectors.some((sel) => !!target.closest(sel));
  }

  private isPrimeNgOverlayEvent(e: any): boolean {
    const targetEl = this.getEventTargetElement(e?.target);
    if (targetEl && this.isPrimeNgOverlayInteraction(targetEl)) return true;

    // composedPath catches cases where target is not an element
    const path = typeof e?.composedPath === 'function' ? e.composedPath() : [];
    if (!Array.isArray(path) || path.length === 0) return false;

    for (const node of path) {
      if (!(node instanceof HTMLElement)) continue;
      if (this.isPrimeNgOverlayInteraction(node)) return true;
    }
    return false;
  }
  constructor(private advSearchService: AdvSearchService, private userDataService: UserDataService, private tabDataService: TabDataService, private inboxService: InboxService, private formBuilder: FormBuilder) {
    // store form data in service so when reopen the last searched data is prepopulated
    this.advSearchForm = formBuilder.group({
      content: [this.advSearchService.advSearchFormData.content, Validators.required],
      subject: [this.advSearchService.advSearchFormData.subject, Validators.required],
      // Recipient-related fields shown as free-text inputs in the template.
      // These were previously reset via DOM manipulation; binding them here lets Reset work naturally.
      to: [this.advSearchService.advSearchFormData.to || '', []],
      from: [this.advSearchService.advSearchFormData.from || '', []],
      cc: [this.advSearchService.advSearchFormData.cc || '', []],
      datePreset: ['ANY', []],
      searchInScope: [this.advSearchService.advSearchFormData.searchInScope || 'ALL', []],
      startDt: [this.advSearchService.advSearchFormData.startDt, Validators.required],
      endDt: [this.advSearchService.advSearchFormData.endDt, Validators.required],
      attachment: [this.advSearchService.advSearchFormData.attachment, Validators.required],

      // Added filters (shown only when selected in Add filters)
      filename: [this.advSearchService.advSearchFormData.filename || '', []],
      sizeComparator: [this.advSearchService.advSearchFormData.sizeComparator || '', []],
      sizeValue: [this.advSearchService.advSearchFormData.sizeValue ?? null, [Validators.min(0)]],
      sizeUnit: [this.advSearchService.advSearchFormData.sizeUnit || 'MB', []],
      tag: [this.advSearchService.advSearchFormData.tag || '', []],
      clientCategory: [this.advSearchService.advSearchFormData.clientCategory || '', []],
      status: [this.advSearchService.advSearchFormData.status || '', []],
      searchInSnoozed: [this.advSearchService.advSearchFormData.searchInSnoozed || false, []]
    });
  }

  /** Client Category add-filter dropdown: options from user session (id, categoryName, colorCode). */
  private refreshClientCategoryOptions(): void {
    const selectPlaceholder = { label: 'Select', value: '' };
    const list: ClientCategory[] | undefined =
      this.userDataService.loggedInUserInfo?.clientCategories;
    if (!list?.length) {
      this.clientCategoryOptions = [selectPlaceholder];
      return;
    }
    const seen = new Set<string>();
    const options: Array<{ label: string; value: string }> = [];
    for (const c of list) {
      const name = c?.categoryName?.trim();
      if (!name || seen.has(name)) {
        continue;
      }
      seen.add(name);
      options.push({ label: name, value: name });
    }
    this.clientCategoryOptions = [selectPlaceholder, ...options];
  }

  ngOnInit() {
    this.refreshClientCategoryOptions();
    this.advSearchError = false;
    // Max date for calendars: end of today (local), so only today and past dates are selectable; tomorrow is excluded
    const endOfToday = new Date();
    endOfToday.setHours(23, 59, 59, 999);
    this.maxSelectableDate = endOfToday;
    // Ensure date fields follow the selected preset on initial load
    this.onDatePresetChange(this.advSearchForm.get('datePreset')?.value);
    this.updateViewportFlags();

    const sizeVal = this.advSearchForm.get('sizeValue')?.value;
    if (sizeVal !== null && sizeVal !== undefined && sizeVal !== '') {
      const n = typeof sizeVal === 'number' ? sizeVal : Number(String(sizeVal).trim());
      if (!Number.isNaN(n) && n < 0) {
        this.advSearchForm.patchValue({ sizeValue: 0 }, { emitEvent: false });
      }
    }

    /*  TO DO QmaConstant.inquiryStatusEnum.forEach(elem => {
    /*  QmaConstant.inquiryStatusEnum.forEach(elem => {
       let textValue = new TextValue( elem.text, elem.label, elem.value)
       this.status.push(textValue);
     }); */
    // TO DO get data for linkedUsers groupList - This is done in old UI - need to find the usage
    /*  this.advSearchService.getAdvSearchDetails(this.userDataService.requestObj).subscribe(linkedUsersForGroupList => {
       this.advSearchService.linkedUsersForGroupList = linkedUsersForGroupList;
     }); */
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateViewportFlags();
  }

  private updateViewportFlags() {
    this.isSmallViewport = window.innerWidth <= QmaConstant.MOBILE_WIDTH;
  }

  /** Size filter: disallow negatives (keyboard + blur clamp). */
  onSizeValueKeydown(event: KeyboardEvent): void {
    if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }

  onSizeValueBlur(): void {
    const ctrl = this.advSearchForm.get('sizeValue');
    if (!ctrl) return;
    const raw = ctrl.value;
    if (raw === null || raw === undefined || raw === '') {
      ctrl.setValue(null, { emitEvent: true });
      return;
    }
    const n = typeof raw === 'number' ? raw : Number(String(raw).trim());
    if (Number.isNaN(n)) {
      ctrl.setValue(null, { emitEvent: true });
      return;
    }
    const clamped = Math.max(0, n);
    if (clamped !== raw) {
      ctrl.setValue(clamped, { emitEvent: true });
    }
  }

  onDatePresetChange(preset: string) {
    const startCtrl = this.advSearchForm.get('startDt');
    const endCtrl = this.advSearchForm.get('endDt');
    if (!startCtrl || !endCtrl) return;

    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    // For non-custom presets, we set dates automatically and make them non-required.
    if (preset && preset !== 'CUSTOM_RANGE') {
      startCtrl.clearValidators();
      endCtrl.clearValidators();

      if (preset === 'ANY') {
        startCtrl.setValue(null);
        endCtrl.setValue(null);
      } else {
        const start = new Date(todayEnd);
        if (preset === 'LAST_7_DAYS') start.setDate(start.getDate() - 7);
        if (preset === 'LAST_30_DAYS') start.setDate(start.getDate() - 30);
        if (preset === 'LAST_6_MONTHS') start.setMonth(start.getMonth() - 6);
        start.setHours(0, 0, 0, 0);

        startCtrl.setValue(start);
        endCtrl.setValue(todayEnd);
      }

      startCtrl.updateValueAndValidity({ emitEvent: false });
      endCtrl.updateValueAndValidity({ emitEvent: false });
      return;
    }

    // Custom range: show controls and require explicit selection.
    startCtrl.setValidators([Validators.required]);
    endCtrl.setValidators([Validators.required]);
    startCtrl.updateValueAndValidity({ emitEvent: false });
    endCtrl.updateValueAndValidity({ emitEvent: false });
  }
  private applyAdvSearchTextAndRecipientFields(value: any, formData: Record<string, unknown>): void {
    if (value?.content) {
      formData.content = AppUtils.escapeSpecialCharSolrValue(value.content);
      PiwikProUtils.trackJsonDataForEvent(
        this.userDataService.loggedInUserInfo.pivotProConfigEnabled,
        this.userDataService.loggedInUserInfo.userId,
        'Search',
        'Advanced Search in - Content',
        'Click',
        'Advanced Search in - Content',
        0
      );
    }
    if (value?.subject) {
      formData.subject = value.subject;
      PiwikProUtils.trackJsonDataForEvent(
        this.userDataService.loggedInUserInfo.pivotProConfigEnabled,
        this.userDataService.loggedInUserInfo.userId,
        'Search',
        'Advanced Search in - Subject',
        'Click',
        'Advanced Search in - Subject',
        0
      );
    }
    if (value?.to) {
      formData.to = value.to;
    }
    if (value?.from) {
      formData.from = value.from;
    }
    if (value?.cc) {
      formData.cc = value.cc;
    }
  }

  /** If end date is not selected, end date becomes today. */
  private applyAdvSearchDateRangeToFormData(value: any, formData: Record<string, unknown>, todayEnd: Date): void {
    const startDt = value?.startDt;
    const endDt = value?.endDt;
    if (startDt && !endDt) {
      const s = new Date(startDt);
      s.setHours(0, 0, 0, 0);
      formData.startDt = s;
      formData.endDt = todayEnd;
      PiwikProUtils.trackJsonDataForEvent(
        this.userDataService.loggedInUserInfo.pivotProConfigEnabled,
        this.userDataService.loggedInUserInfo.userId,
        'Search',
        'Advanced Search in - From Date',
        'Click',
        'Advanced Search in - From Date',
        0
      );
      return;
    }
    if (startDt && endDt) {
      const s = new Date(startDt);
      s.setHours(0, 0, 0, 0);
      formData.startDt = s;
      const e = new Date(endDt);
      e.setHours(23, 59, 59, 999);
      formData.endDt = e;
      PiwikProUtils.trackJsonDataForEvent(
        this.userDataService.loggedInUserInfo.pivotProConfigEnabled,
        this.userDataService.loggedInUserInfo.userId,
        'Search',
        'Advanced Search in - End Date',
        'Click',
        'Advanced Search in - End Date',
        0
      );
    }
  }

  private applyAdvSearchAttachmentAndAddonFilters(value: any, formData: Record<string, unknown>): void {
    this.applyAttachmentFilter(value, formData);
    this.applyFilenameAndSizeFilters(value, formData);
    this.applyTagListAndClientCategory(value, formData);
    this.applyStatusFilter(value, formData);
    this.applySearchInSnoozedFilter(value, formData);
  }

  private applyAttachmentFilter(value: any, formData: Record<string, unknown>): void {
    if (!value?.attachment) return;
    formData.attachment = true;
    PiwikProUtils.trackJsonDataForEvent(
      this.userDataService.loggedInUserInfo.pivotProConfigEnabled,
      this.userDataService.loggedInUserInfo.userId,
      'Search',
      'Advanced Search in - Attachment',
      'Click',
      'Advanced Search in - Attachment',
      0
    );
  }

  private applyFilenameAndSizeFilters(value: any, formData: Record<string, unknown>): void {
    if (value?.filename) {
      formData.filename = value.filename;
    }
    if (value?.sizeComparator) {
      formData.sizeComparator = value.sizeComparator;
    }

    const sv = value?.sizeValue;
    if (sv === null || sv === undefined || sv === '') return;

    const n = typeof sv === 'number' ? sv : Number(String(sv).trim());
    if (Number.isNaN(n)) return;

    formData.sizeValue = Math.max(0, n);
    formData.sizeUnit = value?.sizeUnit || 'MB';
  }

  private applyTagListAndClientCategory(value: any, formData: Record<string, unknown>): void {
    const tagText = this.normalizeTrimmedString(value?.tag);
    if (tagText) {
      const existing = Array.isArray(formData.tagList) ? [...(formData.tagList as string[])] : [];
      if (!existing.includes(tagText)) {
        existing.push(tagText);
      }
      formData.tagList = existing;
    }

    const clientCategory = this.normalizeStringArray(value?.clientCategory);
    if (clientCategory.length > 0) {
      formData.clientCategory = clientCategory;
    }
  }

  private applyStatusFilter(value: any, formData: Record<string, unknown>): void {
    // API expects statusList as string[] (same as tagList / clientCategory).
    const statusItems = this.normalizeStringArray(value?.status);
    if (statusItems.length === 0) {
      return;
    }
    const existing = Array.isArray(formData.statusList) ? [...(formData.statusList as string[])] : [];
    for (const s of statusItems) {
      if (!existing.includes(s)) {
        existing.push(s);
      }
    }
    formData.statusList = existing;
  }

  private applySearchInSnoozedFilter(value: any, formData: Record<string, unknown>): void {
    if (value?.searchInSnoozed) {
      formData.searchInSnoozed = true;
    }
  }

  private normalizeTrimmedString(input: any): string {
    if (input === null || input === undefined) return '';
    const s = String(input).trim();
    return s;
  }

  private normalizeStringArray(input: any): string[] {
    if (input === null || input === undefined) return [];
    if (Array.isArray(input)) {
      return (input as unknown[])
        .map((x) => {
          return String(x).trim(); // NOSONAR
        })
        .filter((s) => s.length > 0);
    }
    const s = String(input).trim();
    return s ? [s] : [];
  }

  private executeAdvSearchRequest(formData: Record<string, unknown>): void {
    this.advSearchError = false;
    this.inboxService.resetRequest = true;
    const scope = this.advSearchForm.controls.searchInScope.value;
    // If "Search In" is not selected (or defaults to ALL), the backend/view payload should be "All".
    const viewName = (!scope || scope === 'ALL') ? 'All' : 'Search';
    this.inboxService.requestObj = { viewName, advanceSearchData: formData };
    if (!scope || scope === 'ALL') {
      this.inboxService.searchBoxes = undefined;
    } else {
      this.inboxService.searchBoxes = scope === 'Sent' ? 'Outbox' : scope;
    }
    this.inboxService.triggerMobileSearch('adv-search');
    this.tabDataService.sendTabData('SEARCH', 0);
    this.tabDataService.drawerStatusChanged.emit(false);
    this.loadFormDataToService();
    this.isSubmitted = true;
    this.searchToggle.emit(this.isSubmitted);
  }

  submitSearch(value: any): void {
    // If the "Add filters" overlay is open, close it on Apply to avoid the UI getting stuck.
    this.isAddFiltersOpen = false;
    this.addFiltersOverlay?.hide();
    this.validateDate();
    if (this.error.isError) {
      return;
    }
    const formData: Record<string, unknown> = {};
    const todayEnd = new Date();
    todayEnd.setHours(23, 59, 59, 999);

    this.applyAdvSearchTextAndRecipientFields(value, formData);
    this.applyAdvSearchDateRangeToFormData(value, formData, todayEnd);
    this.applyAdvSearchAttachmentAndAddonFilters(value, formData);

    this.advSearchError = true;
    if (Object.keys(formData).length > 0) {
      this.executeAdvSearchRequest(formData);
    }
    PiwikProUtils.trackJsonDataForEvent(
      this.userDataService.loggedInUserInfo.pivotProConfigEnabled,
      this.userDataService.loggedInUserInfo.userId,
      'Search',
      'Advanced Search - Submit',
      'Click',
      'Advanced Search - Submit',
      0
    );
  }
  endDateSelect(): void {
    this.error = { isError: false, errorMessage: '' };
  }
  startDateSelect(): void {
    this.error = { isError: false, errorMessage: '' };
  }
  validateDate() {
    this.error = { isError: false, errorMessage: '' };
    const sDateFromForm = this.advSearchForm.controls['startDt'].value;
    const eDateFromForm = this.advSearchForm.controls['endDt'].value;
    if (!this.isNull(eDateFromForm) && this.isNull(sDateFromForm)) {
      this.error = { isError: true, errorMessage: 'Please enter a valid \'From\' date.' };
      return;
    }
    const eDate = eDateFromForm ?? new Date();
    const startDt = sDateFromForm && new Date(sDateFromForm);
    const endDt = new Date(eDate);
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    if (startDt && startDt > today) {
      this.error = { isError: true, errorMessage: '\'From\' Date cannot be after today.' };
      return;
    }
    if (endDt && endDt > today) {
      this.error = { isError: true, errorMessage: '\'To\' Date cannot be after today.' };
      return;
    }
    if (startDt && endDt && startDt > endDt) {
      this.error = { isError: true, errorMessage: '\'From\' Date cannot be greater than the \'To\' Date.' };
    }
  }

  /**
   * Disable Apply only when we would hit the `advSearchError` flow:
   * - date validation passes, and
   * - no criteria would be added to `formData` (so `Object.keys(formData).length === 0`)
   *
   * If the date is invalid, we keep Apply enabled so the date-specific error (`error.isError`) can show.
   */
  get isApplyDisabled(): boolean {
    const value = this.advSearchForm?.value;
    if (!value) return true;

    const dateValid = this.isDateRangeValidForPreview(value);
    if (!dateValid) return false;

    return !this.hasAnyCriteriaForPreview(value);
  }

  private isDateRangeValidForPreview(value: any): boolean {
    const sDateFromForm = value?.startDt;
    const eDateFromForm = value?.endDt;

    const startMissing = this.isNull(sDateFromForm);
    const endPresent = !this.isNull(eDateFromForm);

    if (endPresent && startMissing) return false;

    const today = new Date();
    today.setHours(23, 59, 59, 999);

    const startDt = startMissing ? null : new Date(sDateFromForm);
    const endDt = endPresent ? new Date(eDateFromForm) : today;

    if (startDt && startDt > today) return false;
    if (endPresent && endDt > today) return false;
    if (startDt && endPresent && startDt > endDt) return false;

    return true;
  }

  private hasAnyCriteriaForPreview(value: any): boolean {
    const str = (x: any): boolean => typeof x === 'string' && x.trim().length > 0;

    // Main criteria
    if (str(value?.content) || str(value?.subject)) return true;
    if (str(value?.to) || str(value?.from) || str(value?.cc)) return true;

    // Attachment
    if (value?.attachment === true) return true;

    // Added filters
    if (str(value?.filename) || str(value?.tag)) return true;

    // Mirrors `applyFilenameAndSizeFilters`: sizeComparator is added to `formData`
    // when present, even if `sizeValue` is missing.
    if (str(value?.sizeComparator)) return true;

    // Mirrors `applyFilenameAndSizeFilters`: if sizeValue parses to a number, it is added
    // (sizeUnit is also set), even if sizeComparator is blank.
    const sv = value?.sizeValue;
    const hasSizeValueRaw = sv !== null && sv !== undefined && String(sv).trim() !== '';
    if (hasSizeValueRaw) {
      const n = typeof sv === 'number' ? sv : Number(String(sv).trim());
      if (!Number.isNaN(n)) return true;
    }

    if (str(value?.clientCategory) || str(value?.status)) return true;
    if (value?.searchInSnoozed === true) return true;

    // Date criteria: `applyAdvSearchDateRangeToFormData` only adds fields when startDt exists.
    return !this.isNull(value?.startDt);
  }
  // Jira : 4885 : advance search date issue
   // Null value check function
   isNull(input) {
    if (input === "" || input === undefined || input == null) {
      return true;
    }
    return false;
  }
  loadFormDataToService() {
    this.advSearchService.advSearchFormData.content = this.advSearchForm.controls.content.value;
    this.advSearchService.advSearchFormData.subject = this.advSearchForm.controls.subject.value;
    this.advSearchService.advSearchFormData.to = this.advSearchForm.controls.to.value;
    this.advSearchService.advSearchFormData.from = this.advSearchForm.controls.from.value;
    this.advSearchService.advSearchFormData.cc = this.advSearchForm.controls.cc.value;
    this.advSearchService.advSearchFormData.startDt = this.advSearchForm.controls.startDt.value;
    this.advSearchService.advSearchFormData.endDt = this.advSearchForm.controls.endDt.value;
    this.advSearchService.advSearchFormData.attachment = this.advSearchForm.controls.attachment.value;
    this.advSearchService.advSearchFormData.searchInScope = this.advSearchForm.controls.searchInScope.value;

    // Persist added filter values (selection list still resets on close)
    this.advSearchService.advSearchFormData.filename = this.advSearchForm.controls.filename.value;
    this.advSearchService.advSearchFormData.sizeComparator = this.advSearchForm.controls.sizeComparator.value;
    this.advSearchService.advSearchFormData.sizeValue = this.advSearchForm.controls.sizeValue.value;
    this.advSearchService.advSearchFormData.sizeUnit = this.advSearchForm.controls.sizeUnit.value;
    this.advSearchService.advSearchFormData.tag = this.advSearchForm.controls.tag.value;
    this.advSearchService.advSearchFormData.clientCategory = this.advSearchForm.controls.clientCategory.value;
    this.advSearchService.advSearchFormData.status = this.advSearchForm.controls.status.value;
    this.advSearchService.advSearchFormData.searchInSnoozed = this.advSearchForm.controls.searchInSnoozed.value;
  }
  clearSearch() {
    //Jira : 4540 Advance Search radio button
    // Reset dynamically added "Add filters" selections/rows.
    this.selectedEnhancedFilterKeys = [];
    this.isAddFiltersOpen = false;
    this.addFiltersOverlay?.hide();

    this.advSearchService.advSearchFormData.content = '';
    this.advSearchService.advSearchFormData.subject = '';
    this.advSearchService.advSearchFormData.to = '';
    this.advSearchService.advSearchFormData.from = '';
    this.advSearchService.advSearchFormData.cc = '';
    this.advSearchService.advSearchFormData.startDt = '';
    this.advSearchService.advSearchFormData.endDt = '';
    this.advSearchService.advSearchFormData.attachment = false;
    this.advSearchService.advSearchFormData.searchInScope = 'ALL';
    this.advSearchService.advSearchFormData.filename = '';
    this.advSearchService.advSearchFormData.sizeComparator = '';
    this.advSearchService.advSearchFormData.sizeValue = null;
    this.advSearchService.advSearchFormData.sizeUnit = 'MB';
    this.advSearchService.advSearchFormData.tag = '';
    this.advSearchService.advSearchFormData.clientCategory = '';
    this.advSearchService.advSearchFormData.status = '';
    this.advSearchService.advSearchFormData.searchInSnoozed = false;
    this.error.isError = false;
    this.advSearchError = false;
    this.inboxService.triggerResetSearch('adv-search');

    this.advSearchForm.reset(
      {
        'content': '',
        'subject': '',
        'to': '',
        'from': '',
        'cc': '',
        'startDt': '',
        'endDt': '',
        'attachment': false,
        'searchInScope': 'ALL',
        'datePreset': 'ANY',
        'filename': '',
        'sizeComparator': '',
        'sizeValue': null,
        'sizeUnit': 'MB',
        'tag': '',
        'clientCategory': '',
        'status': '',
        'searchInSnoozed': false
      }
    );

    // Ensure datePreset change logic updates validators and clears the date fields.
    this.onDatePresetChange('ANY');
  }
  toggleAddFilterMenu(event: Event, target: HTMLElement) {
    event.stopPropagation();
    if (this.areAllAddFiltersSelected) return;
    this.addFiltersOverlay?.toggle(event as any, target);
  }

  isAddFilterSelected(key: string): boolean {
    return this.selectedEnhancedFilterKeys.includes(key);
  }

  get areAllAddFiltersSelected(): boolean {
    return this.selectedEnhancedFilterKeys.length >= this.addFilterOptions.length;
  }

  private scrollEnhancedSearchBodyToBottom(): void {
    // `.enhanced-search-body` is the scrollable area within the modal-like "advance search" container.
    const hostEl: HTMLElement | null = this.advSearchContainer?.nativeElement ?? null;
    const scrollNode = hostEl?.querySelector('.enhanced-search-body');
    if (!(scrollNode instanceof HTMLElement)) return;
    const scrollEl = scrollNode;
    // Smooth scroll to bottom so the newly added filter row is visible.
    const top = scrollEl.scrollHeight;
    if (typeof scrollEl.scrollTo === 'function') {
      scrollEl.scrollTo({ top, behavior: 'smooth' });
    } else {
      scrollEl.scrollTop = top;
    }
  }

  private queueScrollEnhancedSearchBodyToBottom(): void {
    // Wait for Angular to render the new filter row before scrolling.
    setTimeout(() => {
      const raf = typeof requestAnimationFrame === 'function' ? requestAnimationFrame : (cb: () => void) => setTimeout(cb, 0);
      raf(() => this.scrollEnhancedSearchBodyToBottom());
    });
  }

  onAddFilterSelected(key: string) {
    if (!key || this.isAddFilterSelected(key)) return;
    this.selectedEnhancedFilterKeys = [...this.selectedEnhancedFilterKeys, key];
    this.queueScrollEnhancedSearchBodyToBottom();
  }

  onAddFilterOptionClick(event: Event, key: string) {
    event.stopPropagation();
    this.onAddFilterSelected(key);
    // Keep the menu open so the user can add multiple filters; close when all are chosen.
    if (this.areAllAddFiltersSelected) {
      this.addFiltersOverlay?.hide();
    }
  }
}
